export const sortCategories = [
    { name: 'All', id: 'all', arrow: false, asc: true },
    { name: 'Collection Date', id: 'collectionDate', arrow: false, asc: true },
    { name: 'Amount', id: 'amount', arrow: false, asc: true },
]